import { Helmet } from "react-helmet-async";
import logo from "../components/images/LOGO.png";
import { imgPlaceholder } from "../components/utils/Utils";
import { useParams } from "react-router-dom";

export const PageWrapper = (props) => {
  // logo with full url
  const { element, image, description, useIdAsTitle } = props;
  const url = "https://www.airon.no";
  const fullLogoUrl = url + logo;
  const fullImagePath = image ? url + image : url + imgPlaceholder;
  const { id, slug } = useParams();

  const uppcaseFirstLetter = (string) =>
    string.charAt(0).toUpperCase() + string.slice(1);

  const slugToTitle = (slug) => {
    if (!slug) return "";
    const words = slug.split("-");
    const title = words.map((word) => uppcaseFirstLetter(word)).join(" ");
    return title;
  };

  // Use slug if available, otherwise use id
  const identifier = slug || id;
  const title =
    (useIdAsTitle && identifier ? slugToTitle(identifier) + " - " + props.title : props.title) +
    " - Airon AS";

  // Get SEO data from element if it's a WebPage component
  const getSeoData = () => {
    // Try to get SEO data from React element props
    // This is a workaround - ideally we'd pass SEO data through context or props
    return {
      metaTitle: props.meta_title || null,
      metaDescription: props.meta_description || null,
      metaKeywords: props.meta_keywords || null,
    };
  };

  const seoData = getSeoData();
  const finalTitle = seoData.metaTitle || title;
  const finalDescription = seoData.metaDescription || description;

  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>{finalTitle}</title>
        <meta name="description" content={finalDescription} />
        {seoData.metaKeywords && (
          <meta name="keywords" content={seoData.metaKeywords} />
        )}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Airon AS" />
        <meta name="publisher" content="Airon AS" />
        <meta name="og:title" content={finalTitle} />
        <meta name="og:description" content={finalDescription} />
        <meta property="og:locale" content="nb_NO" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Airon AS" />
        <meta property="og:image" content={fullImagePath} />
        <meta property="og:image:alt" content="Airon AS" />
        <meta name="twitter:card" content={fullImagePath} />
        <meta name="twitter:site" content="@aironas" />
        <meta name="twitter:creator" content="@aironas" />
        <meta name="twitter:title" content={finalTitle} />
        <meta name="twitter:description" content={finalDescription} />
        <link rel="canonical" href={`${url}${window.location.pathname}`} />
      </Helmet>

      {element}
    </>
  );
};
